<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4>Add Session</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="px-1">
    <div class="container session-section px-2 py-0">
      <h3 class="title text-center">Select Services</h3>
      <div class="session-box mt-4 pt-3">
        <div class="row">
          <div class="col-md-6" *ngIf="isSessionAvailable">
            <div class="session-textbox">
              <mat-form-field appearance="fill" class="w-100">
                <mat-date-range-input [rangePicker]="picker" [min]="currentDay">
                  <input matStartDate placeholder="Start Date" [(ngModel)]="fromDate" readonly
                    (click)="openPicker(picker)" />
                  <input matEndDate placeholder="End Date" [(ngModel)]="toDate" readonly (click)="openPicker(picker)"
                    (dateChange)="onDateRangeChange($event)" />
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-6 mt-md-0 mt-2">
            <div class="session-textbox">
              <!-- <form> -->
              <div class="session-search" *ngIf="isUpcomingSessionAvailable">
                <div class="position-relative">
                  <input maxlength="100" type="text" (keyup)="applyFilter($event)" placeholder="Search"
                    class="form-control search-box" [(ngModel)]="searchStr"
                    oninput="this.value = this.value.replace(/^\s+/g, '')" />
                  <i *ngIf="searchStr !== ''" class="fa-solid fa-times search-icon" (click)="clearSearch()"></i>
                  <i *ngIf="searchStr === ''" class="fa-solid fa-magnifying-glass search-icon"></i>
                </div>
              </div>
              <!-- </form> -->
            </div>
          </div>
          <div class="col-md-12">
            <div ngbAccordion>
              <div *ngIf="sessionList.length === 0" class="mt-3 mb-2 text-center">
                <p>No Session record found</p>
              </div>
              <div *ngFor="let session of sessionList" [ngbAccordionItem]="true">
                <h2 [ngbAccordionHeader]="true">
                  <button [ngbAccordionButton]="true">
                    <h5>{{ session.sessionDay }}</h5>
                  </button>
                </h2>
                <div [ngbAccordionCollapse]="true">
                  <div [ngbAccordionBody]="true">
                    <ng-template>
                      <div *ngFor="let detail of session.detailLists" class="class-box justify-content-between mb-3">
                        <div>
                          <h4 class="WrapData" title="{{ detail.className}}">{{ detail.className }}</h4>
                          <p [innerHTML]="detail.sessionStartDateTime | ordinalDate : detail.sessionStartDateTime">
                            <i class="fa-regular fa-calendar-days"></i>
                          </p>
                          <p><i class="fa-regular fa-clock"></i>
                            {{
                            detail.sessionStartDateTime
                            | date: dateFormat.shortTime }} -
                            {{
                            detail.sessionEndDateTime
                            | date: dateFormat.shortTime
                            }}</p>
                          <div class="d-flex gap-2">
                            <span class="WrapData">- {{ detail.hostedBy
                              }}</span>
                            <label class="pointer" (click)="viewDescription(detail)">View</label>
                          </div>
                        </div>
                        <a *ngIf="!detail.isSoldOut" class="btn btn-primary h-50 mt-3 pointer"
                          (click)="addPass(detail)">
                          Book <i class="fa-solid fa-arrow-right ms-2"></i>
                        </a>
                        <a *ngIf="detail.isSoldOut" class="btn btn-primary h-50 mt-3 pointer bookedBtn">
                          Sold-Out
                        </a>
                      </div>
                      <div class="view-more text-end mt-3 pointer" *ngIf="session.detailLists.length > 4">
                        <a (click)="viewMoreSession(session.sessionDay)">
                          View All
                        </a>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 text-center">
        <button class="btn btn-primary-outline previous-btn" (click)="cancel()">
          Previous
        </button>
      </div>
    </div>
  </mat-dialog-content>
</div>